import React, { useState, useEffect } from 'react';
import { styled, SupersetClient, t } from '@superset-ui/core';

import withToasts from 'src/components/MessageToasts/withToasts';
import { theme } from 'src/themeSchema';

import sectionBtnIcon from 'src/assets/images/datax/add.png';
// import cardFolderIcon from 'src/assets/images/datax/white-folder.png';
import cardTilesIcon from 'src/assets/images/datax/tiles-icon.png';
import cardBarsIcon from 'src/assets/images/datax/chart.png';
// import cardDatabaseIcon from 'src/assets/images/datax/database-s.png';

// import chartCardIcon from 'src/assets/images/datax/chart-xl.png';
// import chartCardHoverIcon from 'src/assets/images/datax/chart-xl-color.png';
// import dashboardCardIcon from 'src/assets/images/datax/dashboard-xl.png';
// import dashboardCardHoverIcon from 'src/assets/images/datax/dashboard-xl-color.png';
// import datasetCardIcon from 'src/assets/images/datax/folder-xl.png';
// import datasetCardHoverIcon from 'src/assets/images/datax/folder-xl-color.png';
// import databaseCardIcon from 'src/assets/images/datax/database-xl.png';
// import databaseCardHoverIcon from 'src/assets/images/datax/database-xl-color.png';

import dashboardPlaceholderImage from 'src/assets/images/datax/dashbaord-sample-min.png';
import chartPlaceholderImage from 'src/assets/images/datax/chart-sample-min.png';

import AddDatasetModal from 'src/views/CRUD/data/dataset/AddDatasetModal';
import { DatasourceModal } from 'src/components/Datasource';
import DatabaseModal from 'src/views/CRUD/data/database/DatabaseModal';

import DashboardList from 'src/views/datax/components/DashboardList';
import ChartList from 'src/views/datax/components/ChartList';
import DatasetList, { Dataset } from 'src/views/datax/components/DatasetList';
import DatabaseList from 'src/views/datax/components/DatabaseList';

import { ColumnObject } from 'src/views/CRUD/data/dataset/types';
import { addDangerToast } from 'src/components/MessageToasts/actions';
import { getTabFromWelcomeRoute, getWelcomeRouteWithTab, navigateTo, replaceLastRoute, Routes, saveNavigationSessionStore } from 'src/views/navigation';
import { store } from 'src/views/store';
import { Menu, NoAnimationDropdown } from 'src/common/components';
import Icons from 'src/components/Icons';

import Header from '../components/WelcomeHeader/WelcomeHeader';
import { Card, CardLabel, CardType, DropDownOption } from '../types';
import Section from '../components/Section/Section';
import ViewMoreCard from '../components/ViewMoreCard/Card';
import Dropdown, { DataxDropdownOption } from '../components/Dropdown';

const PAGE_SIZE = 5;

const WelcomeContainer = styled.div`
  // height: 100vh;
  // width: 100vw;
  overflow: hidden;
  background: white;
`;

const WelcomeBody = styled.div`
  paddingTop: 2rem;
  // height:calc(100% - 65px);

  .tab-section{
    height:41px;
    border-bottom:1px solid #EAEAEA;
    background:white;
    display:flex;
    align-items:center;
    .tab-item{
      margin-bottom:-1px;
      margin-right:24px;
      display:flex;
      align-items:center;
      height:100%;
      border-bottom:3px solid white;
      padding-left:32px;
      padding-right:32px;
      cursor:pointer;
      font-style: normal;
      font-weight: bold;
      font-size: 13px;
      line-height: 16px;
      color: #999999;
      :hover{
        color:${theme.colors.primary.base};
      }
    }
    .active-tab{
      border-color:${theme.colors.primary.base};
      color:${theme.colors.primary.base};
    }
  }
  .tab-content{
    height:calc(100% - 41px);
    overflow:hidden;
  }
`;

const getRecentResource = async (urlPath: string, mapperFn: (record: any)=> Card): Promise<Card[]> => {
  try {
    const res = await SupersetClient.get({
      endpoint: `/api/v1/${urlPath}/?q=(order_column:changed_on_delta_humanized,order_direction:desc,page:0,page_size:${PAGE_SIZE})`,
    });
    return res.json.result.map(mapperFn);
  } catch (ex) {
    console.log(ex);
    return [];
  }
}

function Welcome(props: any) {

  const [ activeTab, setActiveTab ] = useState<CardLabel | null>(null);
  
  const [ recentCharts, setRecentCharts ] = useState<Card[]>([]);
  const [ recentDashboards, setRecentDashboards ] = useState<Card[]>([]);
  // const [ recentDatasets, setRecentDatasets ] = useState<Card[]>([]);
  // const [ recentDatabases, setRecentDatabases ] = useState<Card[]>([]);

  const [ mostRecent, setMostRecent ] = useState<Card[]>([]);

  const [datasetAddModalOpen, setDatasetAddModalOpen] =
    useState<boolean>(false);
  const [selectedDataset, setSelectedDataset] =
    useState<Dataset | null>(null);

  const [databaseModalOpen, setDatabaseModalOpen] = useState<boolean>(false);
  const [databaseId, setDatabaseId] = useState<number | null>(null);

  // const navigationState = useSelector<RootState, NavigationState>(state => state.navigation);

  const changeTab = (tab: CardLabel) => {
    setActiveTab(tab);
  }
  
  const fetchRecentCharts = async () => {
    setRecentCharts(await getRecentResource('chart', (chart: any) => ({
      type: CardType.Thumbnail,
      id: chart.id,
      title: chart.slice_name,
      subTitle: chart.changed_on_delta_humanized,
      cardLabel: CardLabel.Chart,
      labelIcon: cardBarsIcon,
      thumbnailUrl: chart.thumbnail_url,
      placeholderImage: chartPlaceholderImage,
      // icon: chartCardIcon,
      // hoverIcon: chartCardHoverIcon,
      lastModifiedAt: Date.parse(chart.changed_on_utc),
      url: chart.url
    })));
  }

  const fetchRecentDashboards = async () => {
    setRecentDashboards(await getRecentResource('dashboard', (dashboard: any) => ({
      type: CardType.Thumbnail,
      id: dashboard.id,
      title: dashboard.dashboard_title,
      subTitle: dashboard.changed_on_delta_humanized,
      cardLabel: CardLabel.Dashboard,
      labelIcon: cardTilesIcon,
      thumbnailUrl: dashboard.thumbnail_url,
      placeholderImage: dashboardPlaceholderImage,
      // icon: chartCardIcon,
      // hoverIcon: chartCardHoverIcon,
      lastModifiedAt: Date.parse(dashboard.changed_on_utc),
      url: dashboard.url
    })));
  }

  // const fetchRecentDatasets = async () => {
  //   setRecentDatasets(await getRecentResource('dataset', (dataset: any) => ({
  //     type: CardType.Icon,
  //     id: dataset.id,
  //     title: dataset.table_name,
  //     subTitle: dataset.changed_on_delta_humanized,
  //     cardLabel: CardLabel.Dataset,
  //     labelIcon: cardFolderIcon,
  //     icon: datasetCardIcon,
  //     hoverIcon: datasetCardHoverIcon,
  //     lastModifiedAt: Date.parse(dataset.changed_on_utc),
  //   })));
  // }

  // const fetchRecentDatabases = async () => {
  //   setRecentDatabases(await getRecentResource('database', (database: any) => ({
  //     type: CardType.Icon,
  //     id: database.id,
  //     title: database.database_name,
  //     subTitle: database.changed_on_delta_humanized,
  //     cardLabel: CardLabel.Database,
  //     labelIcon: cardDatabaseIcon,
  //     icon: databaseCardIcon,
  //     hoverIcon: databaseCardHoverIcon,
  //     lastModifiedAt: Date.parse(database.changed_on),
  //   })));
  // }

  const summarizeMostRecent = () => {
    const allCards = [...recentCharts, ...recentDashboards];
    setMostRecent(allCards
      .sort((a, b) => b.lastModifiedAt - a.lastModifiedAt)
      .slice(0, Math.min(allCards.length, 15)));
  } 

  useEffect(() => {
    fetchRecentCharts();
    fetchRecentDashboards();
    // fetchRecentDatasets();
    // fetchRecentDatabases();

    // const subscription = store.subscribe(() => {
    //   console.log('state updated');
    //   console.log(store.getState());      
    // })

    try {
      const tab = getTabFromWelcomeRoute(window.location.search);
      // Start Navigation history from welcome page with mentioned tab
      setActiveTab(tab);
    } catch (ex) {
      console.log(ex);
      // Set Dashboard as active tab &
      // initialize navigation history with dashboard tab welcome route  
      setActiveTab(CardLabel.Dashboard);
    }
    
    // Persist in session store
    saveNavigationSessionStore(store.getState().navigation);
  }, []);

  useEffect(() => {
    summarizeMostRecent();
  }, [recentCharts, recentDashboards]);

  useEffect(() => {
    updateTabInRoute();
  }, [activeTab]);

  const addChart = () => {
    navigateTo(Routes.NEW_CHART);
    // window.location.assign('/chart/add');
  }
  
  const addDashboard = () => {
    navigateTo(Routes.NEW_DASHBOARD);
    // window.location.assign('/dashboard/new');
  }

  const addDataset = () => {
    setDatasetAddModalOpen(true);
  }

  const addDatabase = () => {
    setDatabaseModalOpen(true);
  }

  const openDatasetModal = (id: number) => {
    SupersetClient.get({
      endpoint: `/api/v1/dataset/${id}`,
    }).then(({ json = {} }) => {
      const addCertificationFields = json.result.columns.map(
        (column: ColumnObject) => {
          const {
            certification: { details = '', certified_by = '' } = {},
          } = JSON.parse(column.extra || '{}') || {};
          return {
            ...column,
            certification_details: details || '',
            certified_by: certified_by || '',
            is_certified: details || certified_by,
          };
        },
      );
      // eslint-disable-next-line no-param-reassign
      json.result.columns = [...addCertificationFields];
      setSelectedDataset(json.result);
    })
    .catch(() => {
      addDangerToast(
        t('An error occurred while fetching dataset related data'),
      );
    });
  }

  const handleCardClick = (card: Card) => {
    if (card.url) {
      navigateTo(card.url);
      // window.location.assign(card.url);
    }
    else if (card.cardLabel === CardLabel.Database) {
      setDatabaseId(card.id);
      setDatabaseModalOpen(true);
    }
    else if (card.cardLabel === CardLabel.Dataset) {
      openDatasetModal(card.id);
    }
  }

  const resetAddDatasetModal = () => {
    setDatasetAddModalOpen(false);
  }

  const resetDatabaseModal = () => {
    setDatabaseModalOpen(false);
    setDatabaseId(null);
  };

  const gotoChartList = () => {
    navigateTo(Routes.CHART_LIST);
    // window.location.assign('/chart/list/');
  };

  const gotoDashboardList = () => {
    navigateTo(Routes.DASHBOARD_LIST);
    // window.location.assign('/dashboard/list/');
  };

  // const gotoDatasetList = () => {
  //   window.location.assign('/tablemodelview/list/');
  // };

  // const gotoDatabaseList = () => {
  //   window.location.assign('/databaseview/list/');
  // };

  /**
   * Update/Initialize the last/new welcome route in stack with current tab
   * Dashboard is active tab by default
   */
  const updateTabInRoute = () => {
    replaceLastRoute(getWelcomeRouteWithTab(activeTab || CardLabel.Dashboard));
  }

  const DropDownOptions: DataxDropdownOption[] = [
    { label: CardLabel.Chart, value: CardLabel.Chart },
    { label: CardLabel.Dashboard, value: CardLabel.Dashboard },
    { label: CardLabel.Dataset, value: CardLabel.Dataset },
    { label: CardLabel.Database, value: CardLabel.Database },
    { label: DropDownOption.SqlLab, value: DropDownOption.SqlLab },
    { label: DropDownOption.Alerts, value: DropDownOption.Alerts },
  ];

  const settingOptions = [
    { label: DropDownOption.UserList, url: Routes.USER_LIST },
    { label: DropDownOption.RoleList, url: Routes.ROLES_LIST },
    { label: DropDownOption.RowLevelSecurity, url: Routes.RLS },
    { label: DropDownOption.ActionLog, url: Routes.ACTION_LOG },
    { label: DropDownOption.AnnotationLayers, url: Routes.ANNOTATION },
    { label: DropDownOption.UserInfo, url: Routes.USER },
    // { label: DropDownOption.Profile, url: Routes.PROFILE },
    { label: DropDownOption.Logout, url: Routes.LOGOUT },
  ];

  const handleDropdownSelect = (value: any) => {
    switch (value) {
      case CardLabel.Chart:
        addChart();
      break;
      
      case CardLabel.Dashboard:
        addDashboard();
      break;

      case CardLabel.Dataset:
        addDataset();
      break;

      case CardLabel.Database:
        addDatabase();
      break;

      case DropDownOption.SqlLab:
        navigateTo(Routes.SQLLAB);
        // window.location.assign('/superset/sqllab?new=true');
      break;

      case DropDownOption.Alerts:
        navigateTo(Routes.ALERTS);
        // window.location.assign('/alert/list');
      break;
    }
  }

  const handleSettingSelect = (select: any) => {
    navigateTo(settingOptions[select.key].url);
  };

  const settingDropDown = (
    <Menu
        onClick={handleSettingSelect}
        selectable={false}
        data-test="header-actions-menu"
        >
          {
            settingOptions.map((val, index)=>{
              return (
                <Menu.Item key={index}>
                  {t(val.label)}
                </Menu.Item>
              )
            })
          }
          
    </Menu>
  );

  const ButtonRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
  `;

  const DropdownButton = styled.div`
    span {
      color: ${({ theme }) => theme.colors.grayscale.base};
      font-size:32px;
    }
  `;

  return (
    <WelcomeContainer>
        <Header
          title={'Dashboard'}
          rightElement={
            <ButtonRow>
              <Dropdown text='Create New' options={DropDownOptions} onSelect={handleDropdownSelect}/>
              <NoAnimationDropdown
                overlay={settingDropDown}
                trigger={['click']}
                className="setting-dropdown"
              >
                <DropdownButton id="setting-menus-dropdown" role="button">
                  <Icons.MoreVert viewBox={'0 0 20 20'}/>
                </DropdownButton>
              </NoAnimationDropdown>
            </ButtonRow>
          }
          />
        <Section
          title='Recently modified'
          cards={mostRecent}
          handleCardClick={handleCardClick}
          />
        <Section
          title='Recent Charts'
          buttonText='Create chart'
          buttonIcon={sectionBtnIcon}
          cards={recentCharts}
          handleBtnClick={addChart}
          handleCardClick={handleCardClick}
          lastCard={
            <ViewMoreCard
                key='chart_view_more'
                text='To see all List Click on “View All”'
                buttonText='View All'
                handleClick={gotoChartList}
              />
          }
          />
        <Section
          title='Recent Dashboards'
          buttonText='Create Dashboard'
          buttonIcon={sectionBtnIcon}
          cards={recentDashboards}
          handleBtnClick={addDashboard}
          handleCardClick={handleCardClick}
          lastCard={
            <ViewMoreCard
                key='dashboard_view_more'
                text='To see all List Click on “View All”'
                buttonText='View All'
                handleClick={gotoDashboardList}
              />
          }
          />
        {/* <Section
          title='Recent Datasets'
          buttonText='Create Dataset'
          buttonIcon={sectionBtnIcon}
          cards={recentDatasets}
          handleBtnClick={addDataset}
          handleCardClick={handleCardClick}
          lastCard={
            <ViewMoreCard
                text='To see all List Click on “View All”'
                buttonText='View All'
                handleClick={gotoDatasetList}
              />
          }
        /> */}
        {/* <Section
          title='Recent Databases'
          buttonText='Create Database'
          buttonIcon={sectionBtnIcon}
          cards={recentDatabases}
          handleBtnClick={addDatabase}
          handleCardClick={handleCardClick}
          lastCard={
            <ViewMoreCard
                text='To see all List Click on “View All”'
                buttonText='View All'
                handleClick={gotoDatabaseList}
              />
          }
        /> */}

        <WelcomeBody>
          { (activeTab === CardLabel.Dashboard) && (
              <DashboardList
                activeViewType={activeTab}
                handleViewTypeChange={changeTab}
                {...props}
              />
            )
          }
          { activeTab === CardLabel.Chart && (
              <ChartList
                activeViewType={activeTab}
               handleViewTypeChange={changeTab}
                {...props}
              />
            )
          }
          { activeTab === CardLabel.Dataset && (
              <DatasetList 
                activeViewType={activeTab}
                handleViewTypeChange={changeTab}
                {...props}
              />
            )
          }
          { activeTab === CardLabel.Database && (
              <DatabaseList
                activeViewType={activeTab}
                handleViewTypeChange={changeTab}
                {...props}
              />
            )
          }
      </WelcomeBody>
      <AddDatasetModal
        show={datasetAddModalOpen}
        onHide={resetAddDatasetModal}
        // onDatasetAdd={fetchRecentDatasets}
      />
      { selectedDataset && (
        <DatasourceModal
          datasource={selectedDataset}
          show={selectedDataset ? true : false}
          onHide={() => setSelectedDataset(null)}
          // onDatasourceSave={fetchRecentDatasets}
        />
      )}
      <DatabaseModal
          databaseId={databaseId}
          show={databaseModalOpen}
          onHide={resetDatabaseModal}
          // onDatabaseAdd={fetchRecentDatabases}
        />
    </WelcomeContainer>
  );
}

export default withToasts(Welcome);
